class CartItems extends HTMLElement {
  constructor() {
    super()
    this.lineItemStatusElement = document.getElementById(
      'shopping-cart-line-item-status'
    )

    const debouncedOnChange = debounce((event) => {
      this.onChange(event)
    }, ON_CHANGE_DEBOUNCE_TIMER)

    this.addEventListener('change', debouncedOnChange.bind(this))
  }

  cartUpdateUnsubscriber = undefined

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === 'cart-items') {
          return
        }
        this.onCartUpdate()
      }
    )
  }
  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber()
    }
  }
  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name')
    )
  }
  getSectionsToRender() {
    return [
      {
        id: 'main-cart',
        section: document.getElementById('main-cart').dataset.id,
        selector: '.main-cart',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.main-cart-footer',
      },
      {
        id: 'cart-count-bubble',
        section: 'cart-count-bubble',
        selector: '.cart-count-bubble',
      },
    ]
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line)

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    })

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text()
      })
      .then((state) => {
        
        const parsedState = JSON.parse(state)
        const quantityElement = document.getElementById(`Quantity-${line}`)
        const items = document.querySelectorAll('.cart-item')
        const cartCount = document.querySelectorAll('.cart')

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value')
          this.updateLiveRegions(line, parsedState.errors)
          return
        }
        const cartFooter = document.querySelector('#main-cart-footer')

        this.classList.toggle('is-empty', parsedState.item_count === 0)
        cartFooter.classList.toggle('is-empty', parsedState.item_count === 0)
        
        if(parsedState.item_count === 0) { 
          cartCount.forEach(count => count.classList.toggle('hidden'))
        }
        this.getSectionsToRender().forEach((section) => {
          if (section.id === 'cart-count-bubble') {
            const cartIcons = document.querySelectorAll('.cart-count-bubble')
            cartIcons.forEach((cartIcon) => {
              cartIcon.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              )
            })
          }
          const elementToReplace = document.getElementById(section.id)

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          )
        })

        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined

        let message = ''
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error
          } else {
            message = window.cartStrings.quantityError.replace(
              '[quantity]',
              updatedValue
            )
          }
        }
        this.updateLiveRegions(line, message)

        const lineItem = document.getElementById(`CartItem-${line}`)

        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          lineItem.querySelector(`[name="${name}"]`).focus()
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' })
      })
      .catch(() => {
        // this.querySelectorAll('.loading-overlay').forEach((overlay) =>
        //   overlay.classList.add('hidden')
        // )
        // const errors =
        //   document.getElementById('cart-errors') ||
        //   document.getElementById('CartDrawer-CartErrors')
        // errors.textContent = window.cartStrings.error
      })
      .finally(() => {
        this.disableLoading(line)
      })
  }
  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const sourceQty = html.querySelector('cart-items')
        this.innerHTML = sourceQty.innerHTML
      })
      .catch((e) => {
        console.error(e)
      })
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`)
    if (lineItemError)
      lineItemError.querySelector('.cart-item__error-text').innerHTML = message

    this.lineItemStatusElement.setAttribute('aria-hidden', true)

    const cartStatus = document.getElementById('cart-live-region-text')
    cartStatus.setAttribute('aria-hidden', false)

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true)
    }, 1000)
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart')

    mainCartItems.classList.add('cart__items--disabled')

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    )

    cartItemElements.forEach((overlay) => overlay.classList.remove('hidden'))
    document.activeElement.blur()
    this.lineItemStatusElement.setAttribute('aria-hidden', false)
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart')
    mainCartItems.classList.remove('cart__items--disabled')

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    )
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    )
    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'))
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'))
  }
}

customElements.define('cart-items', CartItems)

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super()

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value })
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            })
          }, ON_CHANGE_DEBOUNCE_TIMER)
        )
      }
    }
  )
}
